import React from 'react'

function RegenerateIcon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={24}
      fill="none"
      {...props}
    >
      <path
        stroke="#56565A"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.8}
        d="m10.5 2.75 2.867 2.697a.41.41 0 0 1 0 .606L10.5 8.75M13.5 15.25l-2.867 2.697a.41.41 0 0 0 0 .606L13.5 21.25"
      />
      <path
        stroke="#56565A"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.8}
        d="M13.547 5.685a6.5 6.5 0 0 0-5.62 11.381m8.15-10.13a6.5 6.5 0 0 1-5.576 11.39"
      />
    </svg>
  )
}

export default RegenerateIcon
